import type { MenuStudentPort } from '../ports/menu_student_port'
import type { MenuStudentModel } from '@/components/domains/menu_student_model'
import type { ApiError } from '@/core/http/response_error'
import type { ResponseResult } from '@/core/http/response-result'

export class GetAllMenuStudentUseCase {
  constructor(private menuPort: MenuStudentPort) {}

  async execute(idUser: number): Promise<ResponseResult<MenuStudentModel[]>> {
    try {
      return await this.menuPort.getAllWorkshop(idUser)
    } catch (error) {
      const _error: ApiError = error as ApiError
      return {
        STATUS_CODE: 2,
        ERROR: _error,
      }
    }
  }
}
